export default {

  business_types: ['全过程咨询', '项目管理', '房建监理', '市政监理', '造价咨询', 'BIM咨询', '招标代理', '对外合作', '其他'],
  business_type_colors: ['orange', '#369', 'green', 'darkred', 'purple', '#3af', 'grown', 'pink', '#333'],
  contract_types: ['独立合同', '主合同', '分解合同', '附加合同'],
  contract_type_colors: ['#369', 'green', 'orange'],
  status: ['准备中', '进行中', '已竣工', '已结束', '已中止'],

};
